import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import parser from 'html-react-parser';

const PrivacyPolicyContent = () => {
  const { t } = useLanguage();

  // Map section IDs to translation keys
  const sections = [
    { id: 'overview', key: 'privacy.sections.overview' },
    { id: 'hosting', key: 'privacy.sections.hosting' },
    { id: 'general-info', key: 'privacy.sections.generalInfo' },
    { id: 'data-collection', key: 'privacy.sections.dataCollection' },
    { id: 'social-media', key: 'privacy.sections.socialMedia' },
    { id: 'newsletter', key: 'privacy.sections.newsletter' },
    { id: 'plugins-tools', key: 'privacy.sections.pluginsTools' },
  ];

  return (
    <div className="st-privacy-policy-content">
      <h1 className="st-privacy-policy-title">{t('privacy.meta.title')}</h1>
      <p className="st-privacy-policy-updated">
        <strong>{t('privacy.lastUpdatedLabel')}:</strong> {t('privacy.lastUpdated')}
      </p>

      {sections.map((section) => (
        <section key={section.id} id={section.id} className="st-privacy-section">
          <h2 className="st-privacy-section-title">
            {t(`${section.key}.title`)}
          </h2>
          <div className="st-privacy-section-content">
            {parser(t(`${section.key}.content`))}
          </div>
        </section>
      ))}
    </div>
  );
};

export default PrivacyPolicyContent;
